import { createApp } from "vue";
import VueLazyload from "vue-lazyload";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";

import "./plugins/adaptive";
import "./styles/common.less";
import "./styles/vant.less";
import { myVanToast, myDialog } from "./plugins/vant";
import globalElementsMixins from "./plugins/elements";
import SvgIcon from "@/icons";
import api from "./service/api";

// walletconnect配置
import "./contract/wallet/web3ModalConfig";
// web3 提供器
import web3Provider from "./contract/provider";
// 初始化合约
import { initContracts, initContractsSend } from "./contract/pool/bome";
initContracts();
initContractsSend();

const app = createApp(App);

app.config.globalProperties.$web3 = web3Provider;
app.config.globalProperties.$initContracts = initContracts();
app.config.globalProperties.$initContractsSend = initContractsSend();

app.config.globalProperties.$Toast = myVanToast;
app.use(myDialog());
app.mixin(globalElementsMixins);
app.component("svg-icon", SvgIcon);
app.config.globalProperties.$api = api;

app.use(store).use(i18n).use(router).use(VueLazyload).mount("#app");
